import { render, staticRenderFns } from "./MassAddShortlists.vue?vue&type=template&id=57f0bca2&"
import script from "./MassAddShortlists.vue?vue&type=script&lang=js&"
export * from "./MassAddShortlists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports